module.exports = __webpack_public_path__ + "img/Karim.0f239ee1.jpg";